<template>
  <div class="TopPerformersTopExperts">
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
        <el-card
          class="box-card expert-card"
          v-loading="is_expert_list_loading"
          id="expert_dashboard_top_experts"
        >
          <div class="flex label-md-bold-black" style="padding: 0 15px;">
            <img
              src="../assets/images/rank0.png"
              style="height: 18px; margin-right: 10px;"
            />
            Dashboard

            <!-- <div class="download-btn" style="margin-left: 10px;" v-if="top_expert_list.length" @click="openCsvDownloadDialog('RANK_BOARD_CSV')">
                    DOWNLOAD CSV
                  </div> -->

            <RankBoardExplanatory></RankBoardExplanatory>
          </div>

          <table v-if="top_expert_list.length" class="ranking-board-table">
            <thead>
              <tr>
                <th></th>
                <th></th>
                <th></th>
                <th colspan="2">Reco</th>
              </tr>

              <tr>
                <!-- <th style="min-width: 10px;">Ranking</th> -->

                <th>Name</th>

                <!-- <th :style="{ 'color': active_expert_ranking_sorting == 'rating' ? '#3f67f2' : '' }">
                        <div class="cursor-pointer inline-block" >
                            Rating
                            <i class="el-icon-top" v-if="active_expert_ranking_sorting == 'rating'"></i>
                        </div>
                      </th> -->
                <th
                  class="cursor-pointer"
                  :style="{
                    color:
                      active_expert_ranking_sorting == 'absolute_roi'
                        ? '#3f67f2'
                        : '',
                  }"
                >
                  <!-- <el-popover
                            placement="top"
                            title="Ranking based on Annualised ROI"
                            width="320"
                            trigger="hover"
                            content="">
                        </el-popover> -->
                  <div
                    class="cursor-pointer inline-block"
                    @click="sortTopExpertTableByHeading('absolute_roi')"
                  >
                    Avg ROI
                    <i
                      class="el-icon-top"
                      v-if="active_expert_ranking_sorting == 'absolute_roi'"
                    ></i>
                  </div>
                </th>

                <!-- <th class="cursor-pointer" style="min-width: 79px;" :style="{ 'color': active_expert_ranking_sorting == 'accuracy' ? '#3f67f2' : '' }">

                        <el-popover
                            placement="top"
                            title="Ranking based on accuracy"
                            width="320"
                            trigger="hover"
                            content="Accuracy after adjusting error rate and updated price estimates.">
                        </el-popover>
                        <div class="cursor-pointer inline-block" @click="sortTopExpertTableByHeading('accuracy')">
                        Accuracy
                            <i class="el-icon-top" v-if="active_expert_ranking_sorting == 'accuracy'"></i>
                        </div>

                      </th> -->

                <th
                  class="cursor-pointer"
                  style="min-width: 120px;"
                  :style="{
                    color:
                      active_expert_ranking_sorting == 'success_rate'
                        ? '#3f67f2'
                        : '',
                  }"
                >
                  <!-- <el-popover
                            placement="top"
                            title="Ranking based on success rate"
                            width="320"
                            trigger="hover"
                            content="Success Rate is based on No. of target achieved / No. total recommendations.">
                        </el-popover> -->

                  <div
                    class="cursor-pointer inline-block"
                    @click="sortTopExpertTableByHeading('success_rate')"
                  >
                    Success Rate
                    <i
                      class="el-icon-top"
                      v-if="active_expert_ranking_sorting == 'success_rate'"
                    ></i>
                  </div>
                </th>

                <th
                  class="cursor-pointer"
                  style="min-width: 50px;"
                  :style="{
                    color:
                      active_expert_ranking_sorting == 'live_reco'
                        ? '#3f67f2'
                        : '',
                  }"
                >
                  <!-- <el-popover
                            placement="top"
                            title="Ranking based on Live reco"
                            width="200"
                            trigger="hover"
                            content="Descending order.">
                        </el-popover> -->

                  <div
                    class="cursor-pointer inline-block"
                    @click="sortTopExpertTableByHeading('live_reco')"
                  >
                    Live
                    <i
                      class="el-icon-top"
                      v-if="active_expert_ranking_sorting == 'live_reco'"
                    ></i>
                  </div>
                </th>

                <th
                  class="cursor-pointer"
                  style="min-width: 50px;"
                  :style="{
                    color:
                      active_expert_ranking_sorting == 'total_reco'
                        ? '#3f67f2'
                        : '',
                  }"
                >
                  <!-- <el-popover
                            placement="top"
                            title="Ranking based on Total reco"
                            width="200"
                            trigger="hover"
                            content="Descending order.">
                        </el-popover> -->
                  <div
                    class="cursor-pointer inline-block"
                    @click="sortTopExpertTableByHeading('total_reco')"
                  >
                    Total
                    <i
                      class="el-icon-top"
                      v-if="active_expert_ranking_sorting == 'total_reco'"
                    ></i>
                  </div>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="(expert, index) in top_expert_list"
                :key="index"
                @click="selectExpert(index, expert)"
                :class="{ 'selected-row': selected_expert_index == index }"
              >
                <!-- <td>
                        <Hexagon :rank="expert.rank"></Hexagon>
                      </td> -->

                <td style="text-align: left">
                  <div class="capitalize">{{ expert.full_name }}</div>
                  <div
                    class="input-label-gray top-margin-5"
                    style="font-size: 10px;"
                  >
                    {{ expert.profession }}

                    &nbsp;

                    <div
                      class="input-label-gray cursor-pointer primary-theme-color inline-block"
                      style="font-size: 9px;"
                      v-if="!expert.follow_option_enable"
                      @click="followExpert(index, expert.response_type)"
                    >
                      Follow +
                    </div>
                    <div
                      class="input-label-gray cursor-pointer primary-theme-color inline-block"
                      style="font-size: 9px;"
                      v-if="expert.follow_option_enable"
                      @click="followExpert(index, expert.response_type)"
                    >
                      Unfollow -
                    </div>
                  </div>
                </td>

                <!-- if total reco details more than 90 then displayed annualised roi otherwise displayed '-' -->
                <!-- <td class="border-right-gray" style="min-width: 75px;">
                        <el-rate :value="expert.overall_rating" disabled v-if="expert.overall_rating"></el-rate>
                        <div v-else>-</div>
                      </td> -->

                <td class="border-right-gray">
                  {{ expert.absolute_roi ? expert.absolute_roi + "%" : "-" }}
                </td>

                <!-- <td class="border-right-gray">{{ expert.accuracy ? expert.accuracy + '%' : '-' }}</td> -->

                <td class="border-right-gray">
                  {{
                    expert.success_rate
                      ? expert.success_rate.toFixed(2) + "%"
                      : "-"
                  }}
                </td>

                <td class="primary-theme-color">{{ expert.live_reco }}</td>

                <td>{{ expert.total_reco }}</td>
              </tr>
            </tbody>
          </table>

          <el-pagination
            class="label-xs-bold text-center pagination-pos"
            v-if="top_expert_list.length && number_of_pages > 1"
            small
            :current-page.sync="rank_board_page_no"
            @current-change="handleRankBoardCurrentPageChange"
            :page-size="rank_board_entries_per_page"
            layout="prev, pager, next"
            :total="rank_board_total_entries"
          >
          </el-pagination>

          <!-- if no top experts found then displayed no data -->
          <NoDataFound
            v-if="!top_expert_list.length && !is_expert_list_loading"
          ></NoDataFound>
        </el-card>
      </el-col>

      <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
        <div class="selected-filter-section">
          <div class="label-xs-bold">FILTERS:</div>
          <div style="display: flex; flex-wrap: wrap; margin: 0 5px">
            <div
              class="filters-content"
              v-if="
                (filter_obj.company_list && filter_obj.company_list.length) ||
                  (filter_obj.experts && filter_obj.experts.length)
              "
            >
              Market Expert
            </div>
            <div
              v-if="filter_obj.filters && filter_obj.filters.length"
              class="filters-content"
              v-for="(filter, filter_index) in filter_obj.filters"
              :key="filter_index"
            >
              {{ filter }}
            </div>
            <div
              class="filters-content"
              v-if="typeof filter_obj.rating == 'number'"
            >
              Rating
            </div>
            <div class="filters-content" v-if="filter_obj.sector">
              Sector
            </div>
            <div
              class="filters-content"
              v-if="filter_obj.stocks && filter_obj.stocks.length"
            >
              Stocks
            </div>
            <div
              class="filters-content"
              v-if="
                Object.keys(filter_obj.target_period).length &&
                  filter_obj.target_period.key != 'Long_term'
              "
            >
              {{ filter_obj.target_period.key }}
            </div>
            <div class="filters-content" v-if="filter_obj.term">
              {{ filter_obj.term }}
            </div>
          </div>
        </div>

        <el-card
          class="stock-detail-card"
          v-if="top_expert_list.length"
          id="expert_dashboard_top_expert_falsh_card"
          v-loading="is_flash_card_details_loading"
        >
          <div class="stock-base-details">
            <div class="flex-space-between" style="flex-wrap: wrap;">
              <div class="stock-base-header">
                <!-- <Hexagon class="right-margin-10" :rank="experts_details.data.rank"></Hexagon> -->

                <div>
                  <div
                    class="label-md-bold-black ellipsis cursor-pointer capitalize"
                    style="font-size: 13px; max-width: 130px;"
                    :title="
                      experts_details.data.full_name
                        ? experts_details.data.full_name
                        : ''
                    "
                    @click="
                      goToPastRecoPage(
                        experts_details.data.id,
                        experts_details.data.response_type
                      )
                    "
                  >
                    {{ experts_details.data.full_name }}
                  </div>

                  <div class="role-rating-wrapper">
                    <!-- if total reco details more than 90 then displayed rating otherwise dispayed - -->
                    <label>{{ experts_details.data.profession }}</label>
                    <!-- <el-rate v-model="experts_details.data.overall_rating" disabled v-if="experts_details.data.overall_rating"></el-rate> -->
                  </div>
                </div>
                <!-- <img src="../assets/images/asset7.png" class="cursor-pointer" style="height: 16px; margin-left: auto;" title="Download" v-if="experts_details.stocks.length" @click="downloadFlashCardDetailsInCSV()" /> -->

                <!-- <div class="download-btn" style="margin-left: auto;" v-if="experts_details.stocks.length" @click="openCsvDownloadDialog('FLASH_CARD_CSV')">
                          DOWNLOAD CSV
                      </div> -->
              </div>
            </div>

            <div class="flex-space-between top-margin-15">
              <div>
                <div class="label-xs-black font-weight-500">
                  <!-- <el-tooltip :content="experts_details.data.total_days ? 'No. of Days - ' + String(experts_details.data.total_days) : '-'" placement="top" v-if="experts_details.data.absolute_roi">
                            </el-tooltip> -->

                  {{
                    experts_details.data.absolute_roi
                      ? Number(experts_details.data.absolute_roi).toFixed(2) +
                        "%"
                      : "-"
                  }}
                  <!-- <span class="cursor-pointer">
                            </span> -->
                  <!-- <span v-else>-</span> -->
                </div>
                <div class="input-label-gray">
                  Avg ROI
                  <!-- <span v-if="experts_details.data.total_reco_day">
                          in {{ getYearStringFromNumberOfDays(experts_details.data.total_reco_day) }}
                          </span> -->
                </div>
              </div>

              <!-- <div>
                                <div class="label-xs-black font-weight-500 inline-block">{{ experts_details.data.annual_roi
                                    ? experts_details.data.annual_roi + '%' : '-' }}
                                </div>
                                <div class="input-label-gray" style="font-weight: 400;">Annualised ROI</div>
                            </div> -->
            </div>

            <div
              class="flex-space-between top-margin-15"
              style="align-items: baseline;"
            >
              <!-- <div class="text-center">
                      <div class="label-xs-black font-weight-500">{{ experts_details.data.roi }}%</div>
                      <div class="input-label-gray">ROI</div>
                    </div> -->
              <!-- <div>
                      <div class="label-xs-black font-weight-500">{{ experts_details.data.accuracy ? experts_details.data.accuracy + '%' : '-' }}</div>
                      <div class="input-label-gray">Accuracy</div>
                    </div> -->
              <div>
                <div class="label-xs-black font-weight-500">
                  {{
                    experts_details.data.success_rate
                      ? experts_details.data.success_rate.toFixed(2) + "%"
                      : "-"
                  }}
                </div>
                <div class="input-label-gray">Success Rate</div>
              </div>
              <div class="text-center">
                <span
                  class="primary-theme-color font-06rem"
                  title="Live recommendations"
                  >Live
                </span>
                <span class="primary-theme-color font-08rem">{{
                  experts_details.data.live_reco
                }}</span>
                &nbsp;

                <span class="font-06rem" title="Total recommendations"
                  >Total
                </span>
                <span class="font-08rem">{{
                  experts_details.data.total_reco
                }}</span>
                <div class="input-label-gray" style="font-size: 10px;">
                  Recommendations
                </div>
              </div>
            </div>
          </div>

          <div
            class="stock-accuracy-detail-wrapper"
            v-loading="is_expert_reco_stocks_loading"
          >
            <div class="flex">
              <el-select
                v-model="expert_details_option"
                @change="changeExpertDetailsCategoryDropdown()"
                placeholder="Select"
                size="mini"
                class="mini-select"
                style="width: 120px;"
              >
                <el-option label="Stock" value="stock"></el-option>
                <el-option label="Sector" value="sector"></el-option>
              </el-select>

              <el-select
                v-model="expert_details_category"
                @change="changeExpertDetailsCategoryDropdown()"
                placeholder="Select"
                size="mini"
                class="mini-select left-margin-5"
                style="width: 100%;"
              >
                <el-option
                  v-for="(category,
                  category_index) in expert_details_category_list"
                  :key="category_index"
                  :label="category.lable"
                  :value="category.value"
                ></el-option>
              </el-select>
            </div>

            <div v-if="experts_details.stocks.length">
              <table class="top-margin-5">
                <thead>
                  <tr>
                    <th v-if="expert_details_option == 'stock'">Stock Name</th>
                    <th v-if="expert_details_option == 'sector'">
                      Sector Name
                    </th>
                    <th v-if="expert_details_category == 'accuracy'">
                      Accuracy
                    </th>
                    <th
                      v-if="
                        expert_details_category == 'total_reco' ||
                          expert_details_category == 'live_reco'
                      "
                    >
                      LR/TR
                    </th>
                    <th v-if="expert_details_category == 'rating'">Rating</th>
                    <th v-if="expert_details_category == 'absolute_roi'">
                      Avg ROI
                    </th>
                    <!-- <th v-if="expert_details_category == 'roi' || expert_details_category == 'rating'" >ROI in no. of days</th> -->
                    <th v-if="expert_details_category == 'success_rate'">
                      Success Rate
                    </th>
                    <!-- <th v-if="expert_details_category == 'success_rate'">Reco<br> <span title="Total rcommendations">TR</span> / <span title="Achieved Recommendations">AR</span> </th> -->
                    <!-- <th>&nbsp;</th> -->
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(item, index) in experts_details.stocks"
                    :key="index"
                  >
                    <td style="width: 90px;">
                      <div
                        v-if="expert_details_option == 'stock'"
                        style="display: block;"
                      >
                        <span
                          class="label-md-black"
                          style="font-size: 0.8rem;"
                          @click="redirectStockToPastReco(item)"
                          >{{ item.name }}</span
                        >
                        <div v-if="expert_details_option == 'stock'">
                          <span class="label-xss-black"
                            >₹ {{ item.current_price }}</span
                          >&nbsp;&nbsp;
                          <span
                            :style="{
                              color:
                                item.price_difference < 0
                                  ? '#d60918'
                                  : '#079e3e',
                            }"
                          >
                            <span
                              class="label-xss-black"
                              v-if="item.price_difference < 0"
                              >&#9662;</span
                            >
                            <span class="label-xss-black" v-else>&#9652;</span>
                            &nbsp;<span
                              >{{ item.price_difference }} ({{
                                item.price_potential
                              }}%)</span
                            >
                          </span>
                        </div>

                        <div
                          v-if="expert_details_option == 'stock'"
                          class="input-label-gray"
                          style="font-size: 10px;"
                        >
                          {{
                            item.modified_datetime
                              | stock_live_price_date_filter
                          }}
                        </div>
                      </div>

                      <div v-if="expert_details_option == 'sector'">
                        <span
                          class="label-md-black"
                          style="font-size: 0.8rem;"
                          >{{ item.name }}</span
                        >
                      </div>
                    </td>

                    <td
                      style="width: 90px;"
                      class="label-xss-black"
                      v-if="expert_details_category == 'accuracy'"
                    >
                      {{ item.accuracy ? item.accuracy.toFixed(2) + "%" : "-" }}

                      <div v-if="item.total_result">
                        (Total Results - {{ item.total_result }})
                      </div>
                    </td>

                    <td
                      style="width: 90px;"
                      class="label-xss-black"
                      v-if="
                        expert_details_category == 'total_reco' ||
                          expert_details_category == 'live_reco'
                      "
                    >
                      <span class="primary-theme-color">
                        {{ item.live_reco }}
                      </span>
                      / {{ item.total_reco }}
                    </td>

                    <td
                      style="width: 90px;"
                      class="label-xss-black"
                      v-if="expert_details_category == 'rating'"
                    >
                      <span
                        ><i class="el-icon-star-on" style="color: #f7ba2a;"></i
                      ></span>
                      {{ item.overall_rating }} / 5
                    </td>

                    <td
                      style="width: 90px;"
                      class="label-xss-black"
                      v-if="expert_details_category == 'absolute_roi'"
                    >
                      {{
                        item.absolute_roi
                          ? item.absolute_roi.toFixed(2) + "%"
                          : "-"
                      }}
                      <div style="font-size: 9px;">
                        <!-- (ROI in {{ item.total_performance_day }} days) -->
                      </div>
                    </td>

                    <td
                      style="width: 90px;"
                      class="label-xss-black"
                      v-if="expert_details_category == 'success_rate'"
                    >
                      {{
                        item.success_rate
                          ? item.success_rate.toFixed(2) + "%"
                          : "-"
                      }}
                      <div style="margin-top: 3px; font-size: 9px;">
                        <div>
                          (Reco)
                        </div>
                        <div>
                          (Total-{{ item.total_reco }} /
                          <span class="primary-theme-color"
                            >Achieved-{{ item.target_achieved }}</span
                          >)
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <el-pagination
                class="label-xs-bold text-center top-margin-10"
                v-if="stock_details_total_entries > 3"
                small
                :current-page.sync="stock_details_rank_board_page_no"
                @current-change="handleStockDetailsCurrentPageChange"
                :page-size="stock_details_entries_per_page"
                layout="prev, pager, next"
                :total="stock_details_total_entries"
              >
              </el-pagination>
            </div>

            <!-- if no stocks found then displayed no data -->
            <div
              class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20"
              v-if="
                !is_expert_reco_stocks_loading && !experts_details.stocks.length
              "
            >
              No data available
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- <el-row :gutter="15">
            <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
                <el-card class="box-card relative">
                    <div class="flex-space-between">
                        <div class="label-md-bold-black flex">
                            <img src="../assets/images/asset1.png" style="height: 19px; margin-right: 10px;" />
                            Accuracy
                        </div>
                    </div>

                    <div class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20 absolute" v-if="!is_accuracy_graph_data_available" style="top: 100px!important; left: 0; right: 0;">
                        No data available
                    </div>

                    <div class="graph-container">
                        <div ref="overAllAccuracyGraph" style="width: 100%; height: 285px;"></div>
                    </div>

                    <div class="axis-description">(0% - No data available)</div>
                </el-card>
            </el-col>
        </el-row> -->

    <el-row :gutter="15">
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <el-card class="box-card relative" style="min-height: 300;">
          <div class="flex-space-between">
            <div class="flex">
              <div class="label-md-bold-black">
                <div class="flex">
                  <img
                    src="../assets/images/asset2.png"
                    style="height: 19px; margin-right: 10px;"
                  />
                  Max Recommendation
                </div>
                <div
                  class="font-weight-500 text-right"
                  style="font-size: 10px;"
                >
                  (Expert Category)
                </div>
              </div>
            </div>
          </div>

          <div class="top-margin-15 flex-center">
            <div
              style="background-color: #09a6d0; border-radius: 3px; width: 12px; height: 12px;"
            >
              &nbsp;
            </div>
            &nbsp;<span class="label-xss-black font-weight-600">Live Reco</span>
            &nbsp; &nbsp;
            <div
              style="background-color: #e55575; border-radius: 3px; width: 12px; height: 12px;"
            >
              &nbsp;
            </div>
            &nbsp;<span class="label-xss-black font-weight-600"
              >Total Reco</span
            >
          </div>

          <div
            class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20 absolute"
            v-if="!is_max_reco_expert_graph_data_available"
            style="top: 150px; left: 0; right: 0;"
          >
            No data available
          </div>

          <div class="graph-container">
            <div
              ref="max_reco_expert_graph"
              style="width: 100%; height: 285px;"
            ></div>
          </div>

          <div class="axis-description">(0 - No data available)</div>
        </el-card>
      </el-col>

      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <el-card class="box-card relative" style="min-height: 300;">
          <div class="flex-space-between">
            <div class="flex">
              <div class="label-md-bold-black">
                <div class="flex">
                  <img
                    src="../assets/images/asset2.png"
                    style="height: 19px; margin-right: 10px;"
                  />
                  Max Recommendation
                </div>
                <div
                  class="font-weight-500 text-right"
                  style="font-size: 10px;"
                >
                  (Target Period)
                </div>
              </div>
            </div>

            <!-- <el-select v-model="reco_graph_target_period_option" placeholder="Select" size="mini" style="width: 100px; margin-left: 100px;" v-if="top_expert_list.length" @change="selectOptionsForRecoGraphTargetPeriod()">
                            <el-option
                                v-for="item in max_reco_target_period_option_list"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select> -->
          </div>

          <div
            class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20 absolute"
            v-if="!is_max_reco_target_period_graph_data_available"
            style="top: 150px; left: 0; right: 0;"
          >
            No data available
          </div>

          <div class="graph-container">
            <div
              ref="max_reco_target_period_graph"
              style="width: 100%; height: 320px;"
            ></div>
          </div>

          <div class="axis-description">(0 - No data available)</div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="15">
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <el-card class="box-card relative">
          <div class="flex-space-between">
            <div class="label-md-bold-black flex">
              <img
                src="../assets/images/asset8.png"
                style="height: 19px; margin-right: 10px;"
              />
              Avg ROI
            </div>
          </div>

          <div
            class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20 absolute"
            v-if="!is_roi_graph_data_available"
            style="top: 100px!important; left: 0; right: 0;"
          >
            No data available
          </div>

          <div ref="avg_return_graph" style="width: 100%; height: 285px;"></div>

          <div class="axis-description">(0% - No data available)</div>
        </el-card>
      </el-col>

      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <el-card class="box-card relative">
          <div class="flex label-md-bold-black">
            <img
              src="../assets/images/asset3.png"
              style="height: 19px; margin-right: 10px;"
            />
            Success Rate
          </div>

          <div
            class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20 absolute"
            v-if="!is_success_rate_graph_data_available"
            style="top: 100px!important; left: 0; right: 0;"
          >
            No data available
          </div>

          <div
            ref="success_rate_graph"
            style="width: 100%; height: 285px;"
          ></div>

          <div class="axis-description">(0% - No data available)</div>
        </el-card>
      </el-col>
    </el-row>

    <!-- dialog to select csv metrics -->
    <el-dialog
      :visible.sync="download_csv_dialog_visible"
      class="csv-download-dialog"
      :before-close="handleClose"
    >
      <div slot="title">
        <div class="flex" v-if="downloading_csv_type == 'FLASH_CARD_CSV'">
          <Hexagon
            class="right-margin-10"
            :rank="experts_details.data.rank"
          ></Hexagon>
          <div
            class="label-md-bold-black ellipsis capitalize"
            style="max-width: 200px;"
          >
            {{ experts_details.data.name }}
          </div>
          <label class="label-xs-bold header" style="margin-left: 25px;">{{
            experts_details.data.profession
          }}</label>
          &nbsp;&nbsp;&nbsp;
          <el-rate
            class="header"
            v-model="experts_details.data.overall_rating"
            disabled
            v-if="experts_details.data.total_reco_day >= 90"
          ></el-rate>
        </div>
        <div v-if="downloading_csv_type == 'RANK_BOARD_CSV'">
          <div
            class="label-md-bold-black ellipsis capitalize"
            style="max-width: 200px;"
          >
            Ranking board
          </div>
        </div>
      </div>

      <div v-loading="is_csv_download_in_progress">
        <div
          class="error-text text-center"
          style="font-size: 13px;"
          v-if="no_download_reco_category_selected_error"
        >
          Select any recommendation category
        </div>
        <div>
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-checkbox v-model="all_recos" @change="resetRecoCategory()"
                >All recommendations</el-checkbox
              >

              <div class="top-margin-20">
                <div
                  v-for="(category, category_index) in csv_category"
                  :key="category_index"
                  :style="[category_index > 0 ? { marginTop: '15px' } : '']"
                >
                  <el-row>
                    <el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
                      <div
                        class="label-xs-bold top-margin-5 bottom-margin-5"
                        style="color: #000;"
                      >
                        {{ category.title }}( {{ category.total }} )
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="17" :md="17" :lg="17" :xl="17">
                      <div class="flex">
                        <el-checkbox
                          v-model="category.is_range"
                          @change="
                            no_download_reco_category_selected_error = false
                          "
                          style="margin: 0;"
                          :disabled="all_recos || !category.total"
                          >Range :
                        </el-checkbox>
                        &nbsp;&nbsp;&nbsp;&nbsp;

                        <div class="flex">
                          <el-input-number
                            size="mini"
                            controls-position="right"
                            :min="1"
                            :max="Number(category.total)"
                            :precision="0"
                            v-model="category.from_range"
                            :disabled="!category.is_range"
                            class="range-input"
                          ></el-input-number>

                          &nbsp;&nbsp;&nbsp;
                          <div
                            class="input-label-gray text-center"
                            style="font-size: 13px;"
                          >
                            to
                          </div>
                          &nbsp;&nbsp;&nbsp;

                          <el-input-number
                            size="mini"
                            v-model="category.to_range"
                            controls-position="right"
                            :precision="0"
                            :min="Number(category.from_range + 1)"
                            :max="Number(category.total)"
                            :disabled="
                              !category.is_range || category.from_range == ''
                            "
                            class="range-input"
                          ></el-input-number>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-col>

            <!-- <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
                            <div class="payment-info-section">
                                <div class="text-center sample-btn">
                                    <el-checkbox v-model="free_sample_download" @change="downloadFreeCsv()">Download free sample</el-checkbox>
                                </div>

                                <div class="wallet-section top-margin-20">
                                    <div class="flex">
                                        <i class="el-icon-s-finance wallet-icon"></i>&nbsp;
                                        <span class="label-xss-black-bold">Paytm Wallet</span>
                                    </div>

                                    <div class="flex-space-between top-margin-10">
                                        <div class="label-md-black font-weight-500">Available Balance</div>
                                        <div class="label-md-black font-weight-500">₹ 1220</div>
                                    </div>
                                </div>

                                <div class="wallet-section top-margin-20">
                                    <div class="flex-space-between top-margin-10">
                                        <div class="label-sm-black font-weight-500">Payment</div>
                                        <el-button class="add-btn" size="mini">Add funds</el-button>
                                    </div>

                                    <div class="flex">
                                        <span class="label-lg-bold">₹ 1220</span>
                                    </div>

                                    <div class="top-margin-10" style="color: #999; font-size: 10px;">
                                        <i class="el-icon-info"></i> Amount will deducted from Paytm Wallet
                                    </div>
                                </div>
                            </div>
                        </el-col> -->
          </el-row>
        </div>

        <span slot="footer" class="dialog-footer flex-center top-margin-25">
          <el-button class="dwnld-btn" @click="downloadCsv()"
            >Download</el-button
          >
          <el-button
            class="cancel-btn"
            @click="download_csv_dialog_visible = false"
            >Cancel</el-button
          >
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
var echarts = require("echarts");
import { serverAddr, serverHostName, serverAddrForCSV } from "../networkConfig";
import { filterCallBack } from "../mixins/filter";
import { HelperNetworkCallBack } from "../mixins/Helper";
import CripNotice from "crip-vue-notice";
import NoDataFound from "@/components/NoDataFound.vue";
import { graphData } from "../mixins/BarGraphData";
import { EventBus } from "../eventBus";
import Hexagon from "@/components/Hexagon.vue";
import RankBoardExplanatory from "@/components/RankBoardExplanatory.vue";
import { screenSize } from "../mixins/ScreenSize.js";
import domtoimage from "dom-to-image";
import moment from "moment";
import { credentials } from "../mixins/Credentials.js";

export default {
  name: "TopPerformersTopExperts",

  components: {
    NoDataFound,
    Hexagon,
    RankBoardExplanatory,
  },

  mixins: [
    graphData,
    filterCallBack,
    HelperNetworkCallBack,
    screenSize,
    credentials,
  ],

  props: ["active_sub_menu", "active_period"],

  data() {
    return {
      filter_list: [
        {
          title: "Market Participants",
          experts: [],
        },
        // {
        //     title: 'Search stock'
        // },
        // {
        //     title: "Sectors"
        // },
        // {
        //     title: "Market cap",
        //     filter: ["Large Cap", "Mid Cap", "Small Cap"]
        // },
        {
          title: "Reco type",
          filter: ["Buy", "Sell"],
        },
        // {
        //     title: "Rating"
        // },
        // {
        //     title: "Term"
        // },
        {
          title: "Target period",
        },
      ],

      active_expert_ranking_sorting: "absolute_roi",

      downloading_csv_type: "",

      reco_graph_target_period_option: "Quarter",

      target_period_option_list: [
        {
          label: "Month",
          value: "Month",
        },
        {
          label: "Week",
          value: "Week",
        },
        {
          label: "Quarter",
          value: "Quarter",
        },
        {
          label: "Overall",
          value: "Overall",
        },
        {
          label: "Long term",
          value: "Long_term",
        },
      ],
      max_reco_target_period_option_list: [
        {
          label: "Month",
          value: "Month",
        },
        {
          label: "Week",
          value: "Week",
        },
        {
          label: "Quarter",
          value: "Quarter",
        },
        {
          label: "Long term",
          value: "Long_term",
        },
      ],
      reco_type_option_list: [
        {
          label: "Buy",
          value: "Buy",
        },
        {
          label: "Sell",
          value: "Sell",
        },
        // {
        //     label: 'Hold',
        //     value: 'Hold'
        // },
        {
          label: "Overall",
          value: "Long_term",
        },
      ],

      top_expert_list: [],

      max_reco_target_period_graph_data_list: [],
      ranking_board_expert_list: [],
      ranking_board_company_id_list: [],

      experts_details: {
        data: {},
        stocks: [],
      },

      expert_details_option: "stock",
      expert_details_category: "absolute_roi",
      expert_details_category_list: [
        // {
        //     lable: 'Based on overall Rating',
        //     value: 'rating'
        // },
        {
          lable: "Based on ROI",
          value: "absolute_roi",
        },
        // {
        //     lable: 'Based on Accuracy',
        //     value: 'accuracy'
        // },
        {
          lable: "Based on Success Rate",
          value: "success_rate",
        },
        {
          lable: "Based on live Recommendation",
          value: "live_reco",
        },
        {
          lable: "Based on total Recommendation",
          value: "total_reco",
        },
      ],
      download_csv_dialog_visible: false,
      all_recos: true,
      free_sample_download: false,
      no_download_reco_category_selected_error: false,

      csv_category: [
        {
          title: "ROI",
          total: "",
          is_range: false,
          to_range: "",
          from_range: "",
          card_sub_topic: "roi", //defined this in backend
        },
        {
          title: "Accuracy",
          total: "",
          is_range: false,
          to_range: "",
          from_range: "",
          card_sub_topic: "accuracy", //defined this in backend
        },
        {
          title: "Success Rate",
          total: "",
          is_range: false,
          to_range: "",
          from_range: "",
          card_sub_topic: "success_rate", //defined this in backend
        },
        {
          title: "Total live Reco",
          total: "",
          is_range: false,
          to_range: "",
          from_range: "",
          card_sub_topic: "live_reco", //defined this in backend
        },
        {
          title: "Total Reco",
          total: "",
          is_range: false,
          to_range: "",
          from_range: "",
          card_sub_topic: "total_reco", //defined this in backend
        },
      ],

      filter_obj: {
        filters: [],
        stocks: [],
        sector: "",
        term: "",
        rating: "",
        target_period: {},
        experts: [],
        comapany_list: [],
      },

      csv_final_price: "",
      order_id: "",
      checksum: "",
      url: "",
      transaction_id: "",

      is_expert_list_loading: false,
      is_expert_reco_stocks_loading: false,
      is_flash_card_details_loading: false,
      is_csv_download_in_progress: false,

      is_accuracy_graph_data_available: true,
      is_max_reco_expert_graph_data_available: true,
      is_max_reco_target_period_graph_data_available: true,
      is_roi_graph_data_available: true,
      is_success_rate_graph_data_available: true,

      accuracy_graph_instance: "",
      success_rate_graph_instance: "",
      max_reco_expert_graph_instance: "",
      max_reco_target_period_graph_instance: "",
      avg_return_graph_instance: "",

      selected_expert_index: 0,

      selected_filters: [],

      rank_board_page_no: 1,
      number_of_pages: null,
      rank_board_entries_per_page: 5,
      rank_board_total_entries: null,

      stock_details_rank_board_page_no: 1,
      stock_details_number_of_pages: null,
      stock_details_entries_per_page: 3,
      stock_details_total_entries: null,
      moment: moment,
      credentials: credentials,
    };
  },
  watch: {
    active_period() {
      this.getStockAntsTopExpertsList();
    },
  },
  mounted() {
    // emitted filter list from here to HomePageSideBar.vue
    this.$emit("filters", this.filter_list);

    this.initGraphInstance();

    EventBus.$on("emitSelectedFilters", (filter_obj) => {
      this.filter_obj = JSON.parse(JSON.stringify(filter_obj));
      this.reco_graph_target_period_option = "Quarter";

      //reset page no to 1
      this.rank_board_page_no = 1;
      this.stock_details_rank_board_page_no = 1;

      this.getStockAntsTopExpertsList(); //get top experts ranking api called
    });

    this.getStockAntsTopExpertsList();
  },

  methods: {
    getPriceForFlashCardRecosCsv() {
      let csv_download_category_list = [];
      this.csv_final_price = ""; //reset price
      this.transaction_id = ""; //reset trascation id

      if (this.all_recos) {
        this.csv_category.forEach((e) => {
          let obj = {};
          obj.card_sub_topic = e.card_sub_topic;
          obj.rank_from = "";
          obj.rank_to = "";

          csv_download_category_list.push(obj);
        });
      } else {
        this.csv_category.forEach((e) => {
          if (e.is_range && e.to_range && e.from_range) {
            let obj = {};
            obj.card_sub_topic = e.card_sub_topic;
            obj.rank_from = e.from_range;
            obj.rank_to = e.to_range;

            csv_download_category_list.push(obj);
          }
        });
      }

      if (csv_download_category_list.length) {
        this.is_csv_download_in_progress = true; //enabled loader
        serverAddr
          .post("/stockants_pro/top_flash_card_data_count/", {
            duration: this.filter_obj.target_period.key
              ? []
              : ["IntraDay", "Week", "Month", "Quarter", "Long_term"],
            card_sub_topic: this.expert_details_category,
            stock_sector: this.expert_details_option,
            star_rating: this.filter_obj.rating,
            expert_id:
              this.experts_details.data.response_type != "company"
                ? this.experts_details.data.id
                : "",
            company_id:
              this.experts_details.data.response_type == "company"
                ? this.experts_details.data.id
                : "",
            filters: this.filter_obj.filters,
            sector: this.filter_obj.sector,
            stock_id: this.filter_obj.stocks.length
              ? this.filter_obj.stocks.toString()
              : "",
            target_period: this.filter_obj.target_period,
            download_matrix: csv_download_category_list,
            output_by: "count",
            expert_rating: this.experts_details.data.overall_rating,
          })
          .then((response) => {
            if (response.data.status) {
              this.csv_final_price = response.data.bill_amount;
              //called api to get orider id
              // this.getOrderId(2);     //sent order category id
            } else {
              new CripNotice({
                title: "Oops! Something went wrong!",
                description: "Please try again",
                type: "error",
                duration: 3,
              });
            }

            this.no_download_reco_category_selected_error = false; //disabled error msg
          })
          .catch(
            function(error) {
              console.log(error);
              this.is_csv_download_in_progress = false; //disabled loader

              new CripNotice({
                title: "Oops! Something went wrong!",
                description: "Please try again",
                type: "error",
                duration: 3,
              });
            }.bind(this)
          );
      } else {
        this.no_download_reco_category_selected_error = true; //enabled error msg if not any reco category is selected to download csv
      }
    },

    // api to get price for rank board csv
    getPriceForRankBoardCsv() {
      let csv_download_category_list = [];
      this.csv_final_price = ""; //reset price

      if (this.all_recos) {
        this.csv_category.forEach((e) => {
          let obj = {};
          obj.ranking_by = e.card_sub_topic;
          obj.rank_from = "";
          obj.rank_to = "";

          csv_download_category_list.push(obj);
        });
      } else {
        this.csv_category.forEach((e) => {
          if (e.is_range && e.to_range && e.from_range) {
            let obj = {};
            obj.ranking_by = e.card_sub_topic;
            obj.rank_from = e.from_range;
            obj.rank_to = e.to_range;

            csv_download_category_list.push(obj);
          }
        });
      }

      if (csv_download_category_list.length) {
        this.is_csv_download_in_progress = true; //enabled loader

        serverAddr
          .post("/stockants_pro/expert-ranking-board-csv/", {
            duration: this.filter_obj.target_period.key
              ? []
              : ["IntraDay", "Week", "Month", "Quarter", "Long_term"],
            output_by: "count",
            ranking_by: this.active_expert_ranking_sorting,
            star_rating: this.filter_obj.rating,
            expert_id_list: this.filter_obj.experts,
            company_id_list: this.filter_obj.company_list,
            stock_id: this.filter_obj.stocks.length
              ? this.filter_obj.stocks.toString()
              : "",
            sector: this.filter_obj.sector,
            filters: this.filter_obj.filters,
            target_period: this.filter_obj.target_period,
            download_matrix: csv_download_category_list,
          })
          .then((response) => {
            if (response.data.status) {
              this.csv_final_price = response.data.bill_amount;

              //called api to get orider id
              this.getOrderId(1); //sent order category id
            } else {
              this.is_csv_download_in_progress = false; //disabled loader

              new CripNotice({
                title: "Oops! Something went wrong!",
                description: "Please try again",
                type: "error",
                duration: 3,
              });
            }

            this.no_download_reco_category_selected_error = false; //disabled error msg
          })
          .catch(
            function(error) {
              console.log(error);
              this.is_csv_download_in_progress = false; //disabled loader

              new CripNotice({
                title: "Oops! Something went wrong!",
                description: "Please try again",
                type: "error",
                duration: 3,
              });
            }.bind(this)
          );
      } else {
        this.no_download_reco_category_selected_error = true; //enabled error msg if not any reco category is selected to download csv
      }
    },

    //called function from csv download dialog
    downloadCsv() {
      if (this.downloading_csv_type == "RANK_BOARD_CSV") {
        this.getPriceForRankBoardCsv();
      } else if (this.downloading_csv_type == "FLASH_CARD_CSV") {
        this.getPriceForFlashCardRecosCsv();
      }
    },

    // function to display reco count on download csv dialog
    getRecoCountForFlashCardCsvDialog() {
      let csv_download_category_list = [];

      this.csv_category.forEach((e) => {
        let obj = {};
        obj.card_sub_topic = e.card_sub_topic;
        obj.rank_from = "";
        obj.rank_to = "";

        csv_download_category_list.push(obj);
      });

      if (csv_download_category_list.length) {
        this.is_csv_download_in_progress = true; //enabled loader
        serverAddr
          .post("/stockants_pro/top_flash_card_data_count/", {
            duration: this.filter_obj.target_period.key
              ? []
              : ["IntraDay", "Week", "Month", "Quarter", "Long_term"],
            card_sub_topic: this.expert_details_category,
            stock_sector: this.expert_details_option,
            star_rating: this.filter_obj.rating,
            expert_id:
              this.experts_details.data.response_type != "company"
                ? this.experts_details.data.id
                : "",
            company_id:
              this.experts_details.data.response_type == "company"
                ? this.experts_details.data.id
                : "",
            filters: this.filter_obj.filters,
            sector: this.filter_obj.sector,
            stock_id: this.filter_obj.stocks.length
              ? this.filter_obj.stocks.toString()
              : "",
            target_period: this.filter_obj.target_period,
            download_matrix: csv_download_category_list,
            expert_rating: this.experts_details.data.overall_rating,
          })
          .then((response) => {
            if (response.data.status) {
              let res = response.data.url;

              this.csv_category.forEach((e) => {
                if (e.card_sub_topic == "annual_roi") {
                  e.total = res.annual_roi;
                } else if (e.card_sub_topic == "accuracy") {
                  e.total = res.accuracy;
                } else if (e.card_sub_topic == "success_rate") {
                  e.total = res.success_rate;
                } else if (e.card_sub_topic == "live_reco") {
                  e.total = res.live_recommendation;
                } else if (e.card_sub_topic == "total_reco") {
                  e.total = res.recommendation;
                }
              });
            } else {
              // if api fails then displayed total reco 0
              this.csv_category.forEach((e) => {
                e.total = 0;
              });
            }
            this.is_csv_download_in_progress = false; //disabled loader
          })
          .catch(
            function(error) {
              console.log(error);
              // if api fails then displayed total reco 0
              this.csv_category.forEach((e) => {
                e.total = 0;
              });
              this.is_csv_download_in_progress = false; //disabled loader
            }.bind(this)
          );
      }
    },

    getRecoCountForRankBoardCsvDialog() {
      let csv_download_category_list = [];

      this.csv_category.forEach((e) => {
        let obj = {};
        obj.ranking_by = e.card_sub_topic;
        obj.rank_from = "";
        obj.rank_to = "";

        csv_download_category_list.push(obj);
      });

      if (csv_download_category_list.length) {
        this.is_csv_download_in_progress = true; //enabled loader
        serverAddr
          .post("/stockants_pro/expert-ranking-board-csv/", {
            duration: this.filter_obj.target_period.key
              ? []
              : ["IntraDay", "Week", "Month", "Quarter", "Long_term"],
            output_by: "count",
            ranking_by: this.active_expert_ranking_sorting,
            star_rating: this.filter_obj.rating,
            expert_id_list: this.filter_obj.experts,
            company_id_list: this.filter_obj.company_list,
            stock_id: this.filter_obj.stocks.length
              ? this.filter_obj.stocks.toString()
              : "",
            sector: this.filter_obj.sector,
            filters: this.filter_obj.filters,
            target_period: this.filter_obj.target_period,
            download_matrix: csv_download_category_list,
          })
          .then((response) => {
            if (response.data.status) {
              let res = response.data.url;

              this.csv_category.forEach((e) => {
                if (e.card_sub_topic == "annual_roi") {
                  e.total = res.annual_roi;
                } else if (e.card_sub_topic == "accuracy") {
                  e.total = res.accuracy;
                } else if (e.card_sub_topic == "success_rate") {
                  e.total = res.success_rate;
                } else if (e.card_sub_topic == "live_reco") {
                  e.total = res.live_recommendation;
                } else if (e.card_sub_topic == "total_reco") {
                  e.total = res.recommendation;
                }
              });
            } else {
              // if api fails then displayed total reco 0
              this.csv_category.forEach((e) => {
                e.total = 0;
              });
            }
            this.is_csv_download_in_progress = false; //disabled loader
          })
          .catch(
            function(error) {
              console.log(error);
              // if api fails then displayed total reco 0
              this.csv_category.forEach((e) => {
                e.total = 0;
              });
              this.is_csv_download_in_progress = false; //disabled loader
            }.bind(this)
          );
      }
    },

    downloadFreeCsv() {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "https://demo.stockants.com/web/Media/csv_file/expert_flash_card_csv.xlsx"
      );
      element.setAttribute("download", "");

      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },

    // function to reset reco category after selecting all recos option on csv download dialog
    resetRecoCategory() {
      this.no_download_reco_category_selected_error = false; //disabled error msg
      this.free_sample_download = false;

      this.csv_category.forEach((e) => {
        e.is_range = false;
        e.to_range = "";
        e.from_range = "";
      });
    },

    handleClose() {
      this.download_csv_dialog_visible = false;
    },

    openCsvDownloadDialog(type) {
      // called function to reset previously selected options for csv download
      this.resetRecoCategory();

      this.downloading_csv_type = type; //type from where csv is downloading e.g. flash card or rankboard

      if (type == "RANK_BOARD_CSV") {
        //api to get reco count to display total no of recos on csv download dialog
        this.getRecoCountForRankBoardCsvDialog();
      } else {
        //api to get reco count to display total no of recos on csv download dialog
        this.getRecoCountForFlashCardCsvDialog();
      }
      this.download_csv_dialog_visible = true;
    },

    //function to redirect on other expert past reco track page
    redirectStockToPastReco(stock) {
      if (
        !Object.keys(this.subscribedPlanDetails).length ||
        this.subscribedPlanDetails.plan == "Lite"
      ) {
        this.$store.commit("commitSubscribPlanDialogVisibility", true);
        return;
      }

      this.$router.push({
        name: "expertsPastRecommendations",
        query: { stock_id: stock.id },
      });
    },

    //function to redirect on other expert past reco track page
    //if term filter is not selected then redirect to other expert short term data track page
    //passed stock id as a param
    goToPastRecoPage(user_id, response_type) {
      if (
        !Object.keys(this.subscribedPlanDetails).length ||
        this.subscribedPlanDetails.plan == "Lite"
      ) {
        this.$store.commit("commitSubscribPlanDialogVisibility", true);
        return;
      }

      if (user_id == this.userProfile.id) {
        this.$router.push({ name: "pastRecommendations" });
      } else {
        this.$router.push({
          name: "expertsPastRecommendations",
          query: { user_id: user_id, user: response_type },
        });
      }
    },

    getYearStringFromNumberOfDays(total_days) {
      let year = Math.floor(total_days / 365);
      let month = Math.floor((total_days % 365) / 30) * 30;
      let day = (total_days % 365) % 30;

      if (year) {
        return `${year} years ${day + month} days`;
      } else {
        return `${day + month} days`;
      }
    },

    sortTopExpertTableByHeading(heading) {
      if (heading == "total_reco") {
        this.active_expert_ranking_sorting = heading;
      } else if (heading == "live_reco") {
        this.active_expert_ranking_sorting = heading;
      } else if (heading == "success_rate") {
        this.active_expert_ranking_sorting = heading;
      } else if (heading == "rating") {
        this.active_expert_ranking_sorting = heading;
      } else if (heading == "accuracy") {
        this.active_expert_ranking_sorting = heading;
      } else if (heading == "absolute_roi") {
        this.active_expert_ranking_sorting = heading;
      }

      if (heading == "absolute_roi") {
        this.expert_details_category = "absolute_roi";
      } else {
        this.expert_details_category = heading;
      }

      // reset dropdowns on selecting expert
      this.expert_details_option = "stock";

      //called get top experts api by sorting heading
      this.getStockAntsTopExpertsList();
    },

    handleRankBoardCurrentPageChange(val) {
      // for lite plan or non subscribers restricted to access pagination
      if (
        !Object.keys(this.subscribedPlanDetails).length ||
        this.subscribedPlanDetails.plan == "Lite"
      ) {
        this.rank_board_page_no = 1; //reset to page no 1
        this.$store.commit("commitSubscribPlanDialogVisibility", true);
        return;
      }

      this.rank_board_page_no = val;
      this.stock_details_rank_board_page_no = 1; //reset to page no 1
      this.getStockAntsTopExpertsList();
    },

    selectExpert(index, item) {
      this.selected_expert_index = index;
      this.experts_details.data = item;

      // reset dropdowns on selecting expert
      this.expert_details_option = "stock";

      if (this.active_expert_ranking_sorting == "absolute_roi") {
        this.expert_details_category = "absolute_roi";
      } else {
        this.expert_details_category = this.active_expert_ranking_sorting;
      }

      this.is_expert_reco_stocks_loading = true; //enabled loader

      this.stock_details_rank_board_page_no = 1; //set page no to 1

      this.getSelectedExpertsRecommendedStocks(); //called api to get selected experts stocks
    },

    changeExpertDetailsCategoryDropdown(index, item) {
      this.is_expert_reco_stocks_loading = true; //enabled loader

      this.stock_details_rank_board_page_no = 1; //set page no to 1

      this.getSelectedExpertsRecommendedStocks(); //called api to get selected experts stocks
    },

    clearAvgReturnGraphData() {
      this.horizontal_bar_graph_yaxis_B.data = [];
      this.horizontal_bar_graph_series_B[0].data = [];
      this.reRenderAvgReturnGraphInstance();
    },

    clearMaxRecoExpertGraphData() {
      this.stacked_bar_graph_series = [];
      this.stacked_bar_graph_dataset.source = [];
      this.reRenderMaxRecoExpertGraphInstance();
    },

    clearMaxRecoTargetPeriodGraphData() {
      this.simple_bar_graph_xaxis.data = [];
      // for month wise graph
      this.simple_bar_graph_single_series_obj.data = [];

      // for week and quarter
      this.simple_bar_graph_multiple_series_obj = [];

      this.simple_bar_graph_dataset.source = [];
      this.reRenderMaxRecoTargetPeriodGraphInstance();
    },

    clearSuccessRateGraphData() {
      this.custom_bar_graph_series_xaxis.data = [];
      this.custom_bar_graph_series.data = [];
      this.reRenderSuccessRateGraphInstance();
    },

    //refresh graph instance
    clearMaxRecoExpertGraphInstance: function() {
      this.max_reco_expert_graph_instance.clear();
    },

    //refresh graph instance
    clearMaxRecoTargetPeriodGraphInstance: function() {
      this.max_reco_target_period_graph_instance.clear();
    },

    //refresh graph instance
    // clearAccuracyGraphInstance: function() {
    //     this.accuracy_graph_instance.clear();
    // },

    //refresh graph instance
    clearAvgReturnGraphInstance: function() {
      this.avg_return_graph_instance.clear();
    },

    //refresh graph instance
    clearSuccessRateGraphInstance: function() {
      this.success_rate_graph_instance.clear();
    },

    //to trigger changes on graph e.g. to reflect changes data
    reRenderMaxRecoExpertGraphInstance: function() {
      this.clearMaxRecoExpertGraphInstance();
      this.max_reco_expert_graph_instance.setOption(this.stackedBarGraph);
    },

    // //to trigger changes on graph e.g. to reflect changes data
    reRenderMaxRecoTargetPeriodGraphInstance: function() {
      this.clearMaxRecoTargetPeriodGraphInstance();
      this.max_reco_target_period_graph_instance.setOption(this.simpleBarGraph);
    },

    //to trigger changes on graph e.g. to reflect changes data
    reRenderAvgReturnGraphInstance: function() {
      this.clearAvgReturnGraphInstance();
      this.avg_return_graph_instance.setOption(this.horizontalBarGraphPartB);
    },

    //to trigger changes on graph e.g. to reflect changes data
    reRenderSuccessRateGraphInstance: function() {
      this.clearSuccessRateGraphInstance();
      this.success_rate_graph_instance.setOption(this.customBarGraph);
    },

    //initialize graph
    initGraphInstance() {
      // let over_all_accuracy_graph_container = this.$refs["overAllAccuracyGraph"];
      // this.accuracy_graph_instance = echarts.init(
      //     over_all_accuracy_graph_container,
      //     null,
      //     this.initOptions
      // );

      let success_rate_graph_container = this.$refs["success_rate_graph"];
      this.success_rate_graph_instance = echarts.init(
        success_rate_graph_container,
        null,
        this.initOptions
      );

      let max_reco_expert_graph_container = this.$refs["max_reco_expert_graph"];
      this.max_reco_expert_graph_instance = echarts.init(
        max_reco_expert_graph_container,
        null,
        this.initOptions
      );

      let max_reco_target_period_graph_container = this.$refs[
        "max_reco_target_period_graph"
      ];
      this.max_reco_target_period_graph_instance = echarts.init(
        max_reco_target_period_graph_container,
        null,
        this.initOptions
      );

      let avg_return_graph_container = this.$refs["avg_return_graph"];
      this.avg_return_graph_instance = echarts.init(
        avg_return_graph_container,
        null,
        this.initOptions
      );
    },

    //follow expert api
    followExpert(index, response_type) {
      // if response type is company then sent company id other wise user ids
      //response type company means result displyaed in ranking board is by company wise else expert wise
      if (index != undefined && index != null) {
        let followList = [];
        let company = [];
        let obj = {};

        if (this.top_expert_list[index].follow_option_enable) {
          obj.status = false; //if already added to follow list
        } else {
          obj.status = true; //if not added in follow list
        }

        if (response_type == "company") {
          obj.company_id = this.top_expert_list[index].id;
          company.push(obj);
        } else {
          obj.user_id = this.top_expert_list[index].id;
          followList.push(obj);
        }

        serverAddr
          .post("/stockants/add-to-favroite/", {
            favroite: [],
            followers: followList,
            company: company,
          })
          .then((response) => {
            if (response.data.status) {
              if (this.top_expert_list[index].follow_option_enable) {
                this.top_expert_list[index].follow_option_enable = false; //if already added to follow list
                new CripNotice({
                  title: "Success",
                  description: "Unfollowed",
                  type: "success",
                  duration: 3,
                });
              } else {
                this.top_expert_list[index].follow_option_enable = true; //if not added in follow list
                new CripNotice({
                  title: "Success",
                  description: "Followed",
                  type: "success",
                  duration: 3,
                });
              }
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },

    //api called to get top experts on platform
    getStockAntsTopExpertsList() {
      this.is_expert_list_loading = true; //enabled loader
      this.is_expert_reco_stocks_loading = true; //enabled loader

      // this.accuracy_graph_instance.showLoading(this.loader_default); //enabled loader
      this.avg_return_graph_instance.showLoading(this.loader_default); //enabled loader
      this.success_rate_graph_instance.showLoading(this.loader_default); //enabled loader
      this.max_reco_expert_graph_instance.showLoading(this.loader_default); //enabled loader
      this.max_reco_target_period_graph_instance.showLoading(
        this.loader_default
      ); //enabled loader

      // variables to show no data found labels on graph
      this.is_accuracy_graph_data_available = true;
      this.is_max_reco_expert_graph_data_available = true;
      this.is_max_reco_target_period_graph_data_available = true;
      this.is_roi_graph_data_available = true;
      this.is_success_rate_graph_data_available = true;
      //////////////////////////////////////////

      serverAddr
        .post("/performers/v1/expert/ranking_board/", {
          page_number: this.rank_board_page_no,
          page_per_entries: this.rank_board_entries_per_page,
          duration: this.filter_obj.target_period.key
            ? []
            : ["IntraDay", "Week", "Month", "Quarter", "Long_term"],
          ranking_by: this.active_expert_ranking_sorting,
          star_rating: this.filter_obj.rating,
          expert_id_list: this.filter_obj.experts,
          company_id_list: this.filter_obj.company_list,
          stock_id: this.filter_obj.stocks.length
            ? this.filter_obj.stocks.toString()
            : "",
          sector: this.filter_obj.sector,
          filters: this.filter_obj.filters,
          target_period: this.filter_obj.target_period,
          period: this.active_period,
        })
        .then((response) => {
          if (response.data.status) {
            this.top_expert_list = response.data.data;

            this.selected_expert_index = 0;

            this.ranking_board_expert_list = [];
            this.ranking_board_company_id_list = [];

            this.top_expert_list.forEach((element) => {
              element.rating = this.divideRating(element.rating);

              //if user type is a individual then pushed it in ranking board expert list
              //if user type is a company then pushed it in ranking board company id list
              if (element.response_type == "individual") {
                if (this.ranking_board_expert_list.indexOf(element.id) == -1) {
                  this.ranking_board_expert_list.push(element.id);
                }
              } else if (element.response_type == "company") {
                if (
                  this.ranking_board_company_id_list.indexOf(element.id) == -1
                ) {
                  this.ranking_board_company_id_list.push(element.id);
                }
              }
            });

            //called get overall accuracy graph and max reco api, sent expert list displayed on ranking board table
            this.getOverAllAccuracyGraphData();

            //called get max reco graph data expert sent expert list displayed on ranking board table
            this.getMaxRecoExpertGraphData();

            //called get max reco graph data target period sent expert list displayed on ranking board table
            this.getMaxRecoTargetPeriodGraphData();

            //called get avg return graph data sent expert list displayed on ranking board table
            this.getAvgRoiGraphData();

            if (this.top_expert_list.length) {
              this.experts_details.data = this.top_expert_list[0];
              this.getSelectedExpertsRecommendedStocks(); //called api to get selected experts stocks
            }

            this.rank_board_page_no = response.data.pagination.current_page;
            this.number_of_pages = response.data.pagination.total_pages;
            this.rank_board_total_entries =
              response.data.pagination.total_entries;
            this.is_expert_list_loading = false; //disabled loader
          } else {
            this.ranking_board_expert_list = [];
            this.ranking_board_company_id_list = [];
            this.top_expert_list = [];
            this.is_expert_list_loading = false; //disabled loader
            this.is_expert_reco_stocks_loading = false; //enabled loader

            // this.accuracy_graph_instance.hideLoading(this.loader_default); //disabled loader
            this.avg_return_graph_instance.hideLoading(this.loader_default); //disabled loader
            this.success_rate_graph_instance.hideLoading(this.loader_default); //disabled loader
            this.max_reco_expert_graph_instance.hideLoading(
              this.loader_default
            ); //disabled loader
            this.max_reco_target_period_graph_instance.hideLoading(
              this.loader_default
            ); //disabled loader

            this.clearMaxRecoExpertGraphData(); //clear graph data e.g. xaxis, yaxis, series
            this.clearMaxRecoTargetPeriodGraphData();
            // this.clearAccuracyGraphData();
            this.clearAvgReturnGraphData();
            this.clearSuccessRateGraphData();

            // variables to show no data found labels on graph
            this.is_accuracy_graph_data_available = false;
            this.is_max_reco_expert_graph_data_available = false;
            this.is_max_reco_target_period_graph_data_available = false;
            this.is_roi_graph_data_available = false;
            this.is_success_rate_graph_data_available = false;
            /////////////////////////////////////////////////
          }
        })
        .catch(
          function(error) {
            console.log(error);
            this.ranking_board_expert_list = [];
            this.ranking_board_company_id_list = [];
            this.top_expert_list = [];
            this.is_expert_list_loading = false; //disabled loader

            // this.accuracy_graph_instance.hideLoading(this.loader_default); //disabled loader
            this.avg_return_graph_instance.hideLoading(this.loader_default); //disabled loader
            this.success_rate_graph_instance.hideLoading(this.loader_default); //disabled loader
            this.max_reco_expert_graph_instance.hideLoading(
              this.loader_default
            ); //disabled loader
            this.max_reco_target_period_graph_instance.hideLoading(
              this.loader_default
            ); //disabled loader

            this.clearMaxRecoExpertGraphData(); //clear graph data e.g. xaxis, yaxis, series
            this.clearMaxRecoTargetPeriodGraphData();
            // this.clearAccuracyGraphData();
            this.clearAvgReturnGraphData();
            this.clearSuccessRateGraphData();

            // this.reRenderAccuracyGraphInstance();
            this.reRenderSuccessRateGraphInstance();
            this.reRenderAvgReturnGraphInstance();
            this.reRenderMaxRecoExpertGraphInstance();
            this.reRenderMaxRecoTargetPeriodGraphInstance();

            // variables to show no data found labels on graph
            this.is_accuracy_graph_data_available = false;
            this.is_max_reco_expert_graph_data_available = false;
            this.is_max_reco_target_period_graph_data_available = false;
            this.is_roi_graph_data_available = false;
            this.is_success_rate_graph_data_available = false;
            /////////////////////////////////////////////////
          }.bind(this)
        );
    },

    //function to get more stocks for selcted expert
    handleStockDetailsCurrentPageChange(val) {
      // for lite plan or non subscribers restricted to access pagination
      if (
        !Object.keys(this.subscribedPlanDetails).length ||
        this.subscribedPlanDetails.plan == "Lite"
      ) {
        this.stock_details_rank_board_page_no = 1; //reset to page no 1
        this.$store.commit("commitSubscribPlanDialogVisibility", true);
        return;
      }

      this.stock_details_rank_board_page_no = val;
      this.is_expert_reco_stocks_loading = true; //enabled loader
      this.getSelectedExpertsRecommendedStocks();
    },

    //api to get selected experts stocks
    getSelectedExpertsRecommendedStocks() {
      //if user type (response type) is company then sent company id other wise sent expert id
      serverAddr
        .post("/performers/v1/expert/flash_card/", {
          duration: this.filter_obj.target_period.key
            ? []
            : ["IntraDay", "Week", "Month", "Quarter", "Long_term"],
          card_sub_topic: this.expert_details_category,
          stock_sector: this.expert_details_option,
          expert_id:
            this.experts_details.data.response_type != "company"
              ? this.experts_details.data.id
              : "",
          company_id:
            this.experts_details.data.response_type == "company"
              ? this.experts_details.data.id
              : "",
          page_number: this.stock_details_rank_board_page_no,
          page_per_entries: this.stock_details_entries_per_page,
          filters: this.filter_obj.filters,
          sector: this.filter_obj.sector,
          target_period: this.filter_obj.target_period,
          stock_id: this.filter_obj.stocks.length
            ? this.filter_obj.stocks.toString()
            : "",
          period: this.active_period,
        })
        .then((response) => {
          if (response.data.status) {
            this.experts_details.stocks = []; //cleared before filling new data

            this.experts_details.stocks = response.data.data;

            // this.experts_details.data.annual_avg_return = (response.data.data.annual_avg_return).toFixed(2);
            this.experts_details.data.bse_annual_roi =
              response.data.bse_annual_roi;
            // this.experts_details.data.performance_period_in_days = response.data.data.performance_period_in_days;

            this.is_expert_reco_stocks_loading = false; //disabled loader

            this.stock_details_total_entries =
              response.data.pagination.total_entries;
            this.stock_details_number_of_pages =
              response.data.pagination.total_pages;
          } else {
            this.is_expert_reco_stocks_loading = false; //disabled loader
            this.experts_details.stocks = [];
          }
        })
        .catch(
          function(error) {
            console.log(error);
            this.is_expert_reco_stocks_loading = false; //disabled loader
            this.experts_details.stocks = [];
          }.bind(this)
        );
    },

    //api to get accuracy graph data
    getOverAllAccuracyGraphData() {
      if (this.top_expert_list.length) {
        // this.clearAccuracyGraphData();  //clear graph data e.g. xaxis, yaxis, series
        // this.accuracy_graph_instance.hideLoading(this.loader_default);     //disabled loader

        this.clearSuccessRateGraphData(); //clear graph data e.g. xaxis, yaxis, series
        this.success_rate_graph_instance.hideLoading(this.loader_default); //disabled loader

        // for accuracy chart
        this.horizontal_graph_A_normalised_axis = false; //to show custom formatter

        this.horizontal_bar_graph_xaxis_A.axisLabel.formatter = "{value}%"; //set % formatter to xaxis

        this.top_expert_list.forEach((element, index) => {
          let obj = {};
          obj.name = element.full_name;
          obj.value = element.accuracy ? element.accuracy : 0;
          obj.itemStyle = { color: this.horizontal_bar_graph_colors[index] };
          obj.label = {
            show: true,
            position: "right",
            fontSize: "10",
            color: "#000",
            formatter: "{c}%",
          };

          this.horizontal_bar_graph_yaxis_A.data.push(element.full_name);
          this.horizontal_bar_graph_series_A[0].data.push(obj);
        });

        // for success rate chart
        // to show axis lables vertically
        this.$set(this.custom_bar_graph_series_xaxis.axisLabel, "rotate", 90);
        this.$set(this.custom_bar_graph_series_xaxis.axisLabel, "margin", 10);

        this.custom_bar_graph_series_yaxis.axisLabel.formatter = "{value}%";

        this.top_expert_list.forEach((element, index) => {
          let obj = {};
          obj.name = element.full_name;
          obj.value = element.success_rate
            ? element.success_rate.toFixed(2)
            : 0;
          obj.itemStyle = { color: this.horizontal_bar_graph_colors[index] };
          obj.label = {
            show: true,
            position: "top",
            fontSize: "10",
            color: "#000",
            formatter: "{c}%",
          };

          this.custom_bar_graph_series_xaxis.data.push(element.full_name); //filled x_axis

          this.custom_bar_graph_series.data.push(obj); //pushed series obj
        });

        // this.is_accuracy_graph_data_available = false;

        // this.is_success_rate_graph_data_available = false;

        // this.reRenderAccuracyGraphInstance();

        this.reRenderSuccessRateGraphInstance();

      } else {
        // this.clearAccuracyGraphData();  //clear graph data e.g. xaxis, yaxis, series
        this.clearSuccessRateGraphData(); //clear graph data e.g. xaxis, yaxis, series

        // this.accuracy_graph_instance.hideLoading(this.loader_default);     //disabled loader
        this.success_rate_graph_instance.hideLoading(this.loader_default); //disabled loader

        this.reRenderAccuracyGraphInstance();
        this.reRenderSuccessRateGraphInstance();

        // variables to show no data found labels on graph
        this.is_accuracy_graph_data_available = false;
        this.is_success_rate_graph_data_available = false;
        /////////////////////////////////////////////////
      }
    },

    //api to get accuracy graph data
    getAvgRoiGraphData() {
      if (this.top_expert_list.length) {
        this.clearAvgReturnGraphData(); //clear graph data e.g. xaxis, yaxis, series

        this.avg_return_graph_instance.hideLoading(this.loader_default); //disabled loader

        this.horizontal_graph_B_normalised_axis = false; //to show custom formatter

        this.horizontal_bar_graph_xaxis_B.axisLabel.formatter = "{value}%"; //set % formatter to xaxis

        this.top_expert_list.forEach((element, index) => {
          let obj = {};
          obj.name = element.full_name;
          obj.value = element.annual_roi ? element.annual_roi : 0;
          obj.itemStyle = { color: this.horizontal_bar_graph_colors[index] };
          obj.label = {
            show: true,
            position: "right",
            fontSize: "10",
            color: "#000",
            formatter: "{c}%",
          };

          this.horizontal_bar_graph_yaxis_B.data.push(element.full_name);
          this.horizontal_bar_graph_series_B[0].data.push(obj);
        });

        this.reRenderAvgReturnGraphInstance();
      } else {
        this.clearAvgReturnGraphData(); //clear graph data e.g. xaxis, yaxis, series

        this.avg_return_graph_instance.hideLoading(this.loader_default); //disabled loader

        this.reRenderAvgReturnGraphInstance();

        // variables to show no data found labels on graph
        this.is_roi_graph_data_available = false;
      }
    },

    getMaxRecoExpertGraphData() {
      if (this.top_expert_list.length) {
        this.clearMaxRecoExpertGraphData(); //clear graph data e.g. xaxis, yaxis, series

        this.max_reco_expert_graph_instance.hideLoading(this.loader_default); //disabled loader

        let max_reco = [];

        let x_axis = ["experts"];

        // to show axis lables vertically
        this.$set(this.stacked_bar_graph_xaxis.axisLabel, "rotate", 90);
        this.$set(this.stacked_bar_graph_xaxis.axisLabel, "margin", 10);

        for (var i = 0; i < this.top_expert_list.length; i++) {
          x_axis.push(this.top_expert_list[i].full_name);

          let live_reco = this.top_expert_list[i].live_reco
            ? this.top_expert_list[i].live_reco
            : 0;
          let total_reco = this.top_expert_list[i].total_reco
            ? this.top_expert_list[i].total_reco
            : 0;
          let total = total_reco + live_reco - live_reco;

          max_reco.push([this.top_expert_list[i].full_name, live_reco, total]);
        }

        // if max reco length is 1 then add this dummy value
        //there is issue with displaying single user's value
        //two y axis values can't be plot on single x axis thats why we pushed one dummy value
        if (max_reco.length == 1) {
          x_axis.push("Dummy");
        }

        this.stacked_bar_graph_dataset.source = max_reco;

        [0, 1].forEach((element, index) => {
          let obj = {};
          obj.name = x_axis[index + 1];
          obj.type = "bar";
          obj.seriesLayoutBy = "column";
          obj.barWidth = 35;
          obj.stack = "stack 1";
          obj.label = {
            show: true,
            position: "top",
            color: "#000",
            fontSize: "10",
            align: "right",
            // padding: [0,0,3,0],
            verticalAlign: "top",
            formatter: function(value, index) {
              if (value.componentIndex) {
                //for stacked graph.. componentIndex 0 is first graph and componentIndex 1 second graph..for graph 1 displayd total of graph one and graph second
                return `${value.data[1] + value.data[2]}`;
              } else if (value.componentIndex == 0) {
                // return (`${value.data[1]}`);
                return "";
              } else {
                return "";
              }
            },
          };
          this.stacked_bar_graph_series.push(obj);
        });
        this.stacked_bar_graph_dataset.source.unshift(x_axis);

        this.reRenderMaxRecoExpertGraphInstance();
      } else {
        this.clearMaxRecoExpertGraphData(); //clear graph data e.g. xaxis, yaxis, series
        this.max_reco_expert_graph_instance.hideLoading(this.loader_default); //disabled loader
        this.reRenderMaxRecoExpertGraphInstance();

        this.is_max_reco_expert_graph_data_available = false;
      }
    },

    //api to get max reco graph data target period
    getMaxRecoTargetPeriodGraphData() {
      serverAddr
        .post("/performers/v1/expert/reco/overview/graph", {
          duration: this.filter_obj.target_period.key
            ? []
            : ["IntraDay", "Week", "Month", "Quarter", "Long_term"],
          expert_id_list: this.ranking_board_expert_list,
          company_id_list: this.ranking_board_company_id_list,
          stock_id: this.filter_obj.stocks.length
            ? this.filter_obj.stocks.toString()
            : "",
          filters: this.filter_obj.filters,
          sector_list: this.filter_obj.sector ? [this.filter_obj.sector] : [],
          target_period: this.filter_obj.target_period,
          period: this.active_period,
        })
        .then((response) => {
          if (response.data.status) {
            this.max_reco_target_period_graph_instance.hideLoading(
              this.loader_default
            ); //disabled loader
            if (response.data.x_axis.length && response.data.y_axis.length) {
              this.simple_bar_graph_xaxis.data = response.data.x_axis;

              response.data.y_axis.forEach((element, index) => {
                let obj = {};
                obj.name = this.simple_bar_graph_xaxis.data[index];
                obj.value = element;
                obj.label = {
                  show: true,
                  position: "top",
                  fontSize: "10",
                  color: "#000",
                };

                this.simple_bar_graph_single_series_obj.data.push(obj);
              });
            }

            this.is_multi_graph_color = false;

            this.reRenderMaxRecoTargetPeriodGraphInstance();
          } else {
            this.clearMaxRecoTargetPeriodGraphData(); //clear graph data e.g. xaxis, yaxis, series
            this.max_reco_target_period_graph_instance.hideLoading(
              this.loader_default
            ); //disabled loader
            this.reRenderMaxRecoTargetPeriodGraphInstance();

            // variables to show no data found labels on graph
            this.is_max_reco_target_period_graph_data_available = false;
            /////////////////////////////////////////////////
          }
        })
        .catch(
          function(error) {
            console.log(error);
            this.clearMaxRecoTargetPeriodGraphData(); //clear graph data e.g. xaxis, yaxis, series
            this.max_reco_target_period_graph_instance.hideLoading(
              this.loader_default
            ); //disabled loader
            this.reRenderMaxRecoTargetPeriodGraphInstance();

            // variables to show no data found labels on graph
            this.is_max_reco_target_period_graph_data_available = false;
            /////////////////////////////////////////////////
          }.bind(this)
        );
    },

    getMaxRecoGraphByMonth() {
      this.clearMaxRecoTargetPeriodGraphData(); //clear graph data e.g. xaxis, yaxis, series
      if (this.max_reco_target_period_graph_data_list.length) {
        for (
          var i = 0;
          i < this.max_reco_target_period_graph_data_list.length;
          i++
        ) {
          if (
            this.max_reco_target_period_graph_data_list[i].target_period ==
            "Month"
          ) {
            // variables to show no data found labels on graph
            this.is_max_reco_target_period_graph_data_available = true;
            /////////////////////////////////////////////////

            if (
              this.max_reco_target_period_graph_data_list[i].x_axis.length &&
              this.max_reco_target_period_graph_data_list[i].y_axis.length
            ) {
              this.is_multi_graph_color = false; //set variable true false for multiple graph colors (on bar graph data.js)
              this.is_singleSeriesObjRequired = true; //set variable true false for single and multi series objects(on bar graph data.js)
              this.isCustomFormatterRequired = false; //set variable true false for custom formatter (on bar graph data.js)

              this.simple_bar_graph_xaxis.data = this.max_reco_target_period_graph_data_list[
                i
              ].x_axis;

              this.max_reco_target_period_graph_data_list[i].y_axis.forEach(
                (element, index) => {
                  let obj = {};
                  obj.name = this.simple_bar_graph_xaxis.data[index];
                  obj.value = element;
                  obj.label = {
                    show: true,
                    position: "top",
                    fontSize: "10",
                    color: "#000",
                  };

                  this.simple_bar_graph_single_series_obj.data.push(obj);
                }
              );
            } else {
              // variables to show no data found labels on graph
              this.is_max_reco_target_period_graph_data_available = false;
              /////////////////////////////////////////////////
            }
          }
        }
      } else {
        // variables to show no data found labels on graph
        this.is_max_reco_target_period_graph_data_available = false;
        /////////////////////////////////////////////////
      }
      this.reRenderMaxRecoTargetPeriodGraphInstance();
    },

    getMaxRecoGraphByQuarter() {
      this.clearMaxRecoTargetPeriodGraphData(); //clear graph data e.g. xaxis, yaxis, series
      if (this.max_reco_target_period_graph_data_list.length) {
        for (
          var i = 0;
          i < this.max_reco_target_period_graph_data_list.length;
          i++
        ) {
          if (
            this.max_reco_target_period_graph_data_list[i].target_period ==
            "Quarter"
          ) {
            if (
              this.max_reco_target_period_graph_data_list[i].x_axis.length &&
              this.max_reco_target_period_graph_data_list[i].y_axis.length
            ) {
              // variables to show no data found labels on graph
              this.is_max_reco_target_period_graph_data_available = true;
              /////////////////////////////////////////////////

              // delete this.simple_bar_graph_xaxis.data;    //deletd xaxis data for this graph

              this.is_multi_graph_color = false; //set variable true false for multiple graph colors (on bar graph data.js)
              this.is_singleSeriesObjRequired = true; //set variable true false for single and multi series objects(on bar graph data.js)
              this.isCustomFormatterRequired = false; //set variable true false for custom formatter (on bar graph data.js)

              this.simple_bar_graph_xaxis.data = this.max_reco_target_period_graph_data_list[
                i
              ].x_axis;

              this.max_reco_target_period_graph_data_list[i].y_axis.forEach(
                (element, index) => {
                  let obj = {};
                  obj.name = this.simple_bar_graph_xaxis.data[index];
                  obj.value = element;
                  obj.label = {
                    show: true,
                    position: "top",
                    fontSize: "10",
                    color: "#000",
                  };

                  this.simple_bar_graph_single_series_obj.data.push(obj);
                }
              );
            } else {
              // variables to show no data found labels on graph
              this.is_max_reco_target_period_graph_data_available = false;
              /////////////////////////////////////////////////
            }
          }
        }
      } else {
        // variables to show no data found labels on graph
        this.is_max_reco_target_period_graph_data_available = false;
        /////////////////////////////////////////////////
      }
      this.reRenderMaxRecoTargetPeriodGraphInstance();
    },

    getMaxRecoGraphByWeek() {
      this.clearMaxRecoTargetPeriodGraphData(); //clear graph data e.g. xaxis, yaxis, series
      if (this.max_reco_target_period_graph_data_list.length) {
        for (
          var i = 0;
          i < this.max_reco_target_period_graph_data_list.length;
          i++
        ) {
          if (
            this.max_reco_target_period_graph_data_list[i].target_period ==
            "Week"
          ) {
            if (this.max_reco_target_period_graph_data_list[i].x_axis.length) {
              // variables to show no data found labels on graph
              this.is_max_reco_target_period_graph_data_available = true;
              /////////////////////////////////////////////////

              delete this.simple_bar_graph_xaxis.data; //deletd xaxis data for this graph

              this.is_multi_graph_color = true; //set variable true false for multiple graph colors (on bar graph data.js)
              this.is_singleSeriesObjRequired = false; //set variable true false for single and multi series objects(on bar graph data.js)
              this.isCustomFormatterRequired = false; //set variable true false for custom formatter (on bar graph data.js)

              let max_reco = [];

              max_reco.push(
                ...this.max_reco_target_period_graph_data_list[i].x_axis
              );
              let x_axis = [];
              x_axis.push("experts");

              for (var j = 0; j < max_reco.length; j++) {
                for (var k = 0; k < max_reco[j].length; k++) {
                  if (k == 0) {
                    x_axis.push(max_reco[j][k]); //created first data set for x axis labels
                  }
                }
              }

              this.simple_bar_graph_dataset.source = max_reco;

              [0, 1, 2, 3, 4].forEach((element, index) => {
                //for 4 weeks filled 4 objects in series
                let obj = {};
                obj.type = "bar";
                obj.name = `Week ${index + 1}`;
                obj.label = {
                  show: true,
                  position: "top",
                  fontSize: "10",
                  color: "#000",
                };
                // obj.barWidth = '35%';
                // obj.seriesLayoutBy = 'column';
                this.simple_bar_graph_multiple_series_obj.push(obj);
              });
              this.simple_bar_graph_dataset.source.unshift(x_axis);
            } else {
              // variables to show no data found labels on graph
              this.is_max_reco_target_period_graph_data_available = false;
              /////////////////////////////////////////////////
            }
          }
        }
      } else {
        // variables to show no data found labels on graph
        this.is_max_reco_target_period_graph_data_available = false;
        /////////////////////////////////////////////////
      }
      this.reRenderMaxRecoTargetPeriodGraphInstance();
    },

    getMaxRecoGraphByLongTerm() {
      this.clearMaxRecoTargetPeriodGraphData(); //clear graph data e.g. xaxis, yaxis, series
      if (this.max_reco_target_period_graph_data_list.length) {
        for (
          var i = 0;
          i < this.max_reco_target_period_graph_data_list.length;
          i++
        ) {
          if (
            this.max_reco_target_period_graph_data_list[i].target_period ==
            "Long term"
          ) {
            if (
              this.max_reco_target_period_graph_data_list[i].x_axis.length &&
              this.max_reco_target_period_graph_data_list[i].y_axis.length
            ) {
              // delete this.simple_bar_graph_xaxis.data;    //deletd xaxis data for this graph

              // variables to show no data found labels on graph
              this.is_max_reco_target_period_graph_data_available = true;
              /////////////////////////////////////////////////

              this.is_multi_graph_color = false; //set variable true false for multiple graph colors (on bar graph data.js)
              this.is_singleSeriesObjRequired = true; //set variable true false for single and multi series objects(on bar graph data.js)
              this.isCustomFormatterRequired = false; //set variable true false for custom formatter (on bar graph data.js)

              this.simple_bar_graph_xaxis.data = this.max_reco_target_period_graph_data_list[
                i
              ].x_axis;

              this.max_reco_target_period_graph_data_list[i].y_axis.forEach(
                (element, index) => {
                  let obj = {};
                  obj.name = this.simple_bar_graph_xaxis.data[index];
                  obj.value = element;
                  obj.label = {
                    show: true,
                    position: "top",
                    fontSize: "10",
                    color: "#000",
                  };

                  this.simple_bar_graph_single_series_obj.data.push(obj);
                }
              );
            } else {
              // variables to show no data found labels on graph
              this.is_max_reco_target_period_graph_data_available = false;
              /////////////////////////////////////////////////
            }
          }
        }
      } else {
        // variables to show no data found labels on graph
        this.is_max_reco_target_period_graph_data_available = false;
        /////////////////////////////////////////////////
      }
      this.reRenderMaxRecoTargetPeriodGraphInstance();
    },

    selectOptionsForRecoGraphTargetPeriod() {
      if (this.reco_graph_target_period_option == "Month") {
        this.getMaxRecoGraphByMonth();
      } else if (this.reco_graph_target_period_option == "Quarter") {
        this.getMaxRecoGraphByQuarter();
      } else if (this.reco_graph_target_period_option == "Long_term") {
        this.getMaxRecoGraphByLongTerm();
      } else {
        this.getMaxRecoGraphByWeek();
      }
    },

    goToLink(link) {
      if (link) {
        this.$router.push(link);
      }
    },
  },

  computed: {
    //returns stored user profile from local storage
    userProfile() {
      return JSON.parse(localStorage.getItem("profile"));
    },

    //returns subscribed plan details from local storage
    subscribedPlanDetails() {
      return JSON.parse(localStorage.getItem("plan_details"));
    },
  },

  beforeDestroy() {
    EventBus.$off();
  },
};
</script>

<style lang="scss">
.header-title-color {
  color: #4269f2;
}

.TopPerformersTopExperts .flex-space-between {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.TopPerformersTopExperts .ranking-board-table {
  overflow-x: auto;
  border-spacing: 0;
  border-collapse: collapse;

  .border-right-gray {
    border-right: 1px solid #e9e9e9;
  }

  .border-bottom-gray {
    border-bottom: 1px solid #e9e9e9;
  }

  .bottom-spacing-table-heading {
    padding: 0px 8px 8px 8px;
  }

  width: 100%;

  thead {
    tr {
      th {
        color: #a5a6a8;
        font-size: 13px;
        font-weight: 600;
        padding: 0 5px 5px 5px;
      }
    }

    tr:nth-child(2) {
      border-bottom: 1px solid #e9e9e9;
    }
  }

  tbody {
    tr {
      cursor: pointer;

      td {
        font-size: 13px;
        font-weight: 600;
        text-align: center;
        padding: 15px 10px;
        height: 50px;
      }
    }

    tr:hover {
      background-color: #eff5fe;
    }

    .selected-row {
      background-color: #eff5fe;
    }
  }
}

.TopPerformersTopExperts .stock-detail-card {
  margin: 10px 0px;
}

.TopPerformersTopExperts .stock-base-details {
  background-color: #eff5fe;
  padding: 15px;

  .stock-base-header {
    display: flex;
    width: 100%;
    align-items: start;
  }

  .role-rating-wrapper {
    display: flex;
    align-items: center;

    label {
      font-size: 11px;
      font-weight: 500;
      margin-right: 10px;
    }
  }
}

.stock-accuracy-detail-wrapper {
  padding: 15px;
  min-height: 150px;

  table {
    width: 100%;

    thead {
      th:nth-child(1) {
        text-align: left;
      }

      th {
        font-size: 11px;
        font-weight: 500;
        color: #a5a6a8;
        text-align: center;
        padding: 5px 0 0 0;
      }
    }

    tbody {
      td:nth-child(1) {
        text-align: left;

        div {
          display: flex;
          align-items: center;
          font-size: 10px;
          margin-top: 1px;
        }
      }

      td {
        font-weight: 500;
        text-align: center;
        padding: 5px 0;
      }
    }
  }

  .more-wrapper-btn-section {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .expand_more_wrappers_btn {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 50px;
    height: 20px;
    width: 20px;
    margin: 0px 0px;
    text-align: center;

    .el-icon-arrow-down {
      color: #a5a6a8;
      font-size: 10px;
    }
  }

  .faded-border {
    display: block;
    border: none;
    color: #fff;
    height: 1px;
    background: -webkit-gradient(
      radial,
      50% 50%,
      0,
      50% 50%,
      80,
      from(#ddd),
      to(#fff)
    );
  }
}

@media screen and (max-width: 900px) {
  .TopPerformersTopExperts .ranking-board-table {
    display: block;
  }
}

@media screen and (max-width: 1200px) {
  .TopPerformersTopExperts .ranking-board-table {
    th {
      width: 110px;
    }
  }
}

@media screen and (max-width: 575px) {
  .TopPerformersTopExperts .stock-detail-card {
    margin: 5px !important;
  }

  .TopPerformersTopExperts .stock-accuracy-detail-wrapper {
    padding: 20px 10px;
  }
}
</style>

<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.TopPerformersTopExperts .box-card {
  border-radius: 10px !important;
  border: none;
  box-shadow: none;
}

.TopPerformersTopExperts .expert-card {
  min-height: 550px;
  position: relative;
}

.TopPerformersTopExperts .expert-card .el-card__body {
  padding: 20px 0;
}

.TopPerformersTopExperts .stock-detail-card .el-card__body {
  padding: 0px 0;
}

.TopPerformersTopExperts .NoDataFound {
  padding: 60px 0 0 0;
}

.TopPerformersTopExperts .el-icon-download,
.el-icon-share {
  margin: 0 12px;
}

.TopPerformersTopExperts .el-rate__icon {
  margin-right: 0px !important;
  font-size: 14px !important;
}

.TopPerformersTopExperts .el-pager li.active {
  color: #3f67f2;
}

.TopPerformersTopExperts .el-loading-mask {
  z-index: 1;
}

.TopPerformersTopExperts .role-rating-wrapper .el-rate__icon {
  font-size: 10px !important;
}

.el-tooltip__popper {
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600 !important;
}

.payment-success-dialog {
  .modal-content {
    .dailog-bg {
      background: url("../assets/images/dashboard/dialog-background.png");
      background-repeat: no-repeat;
      background-position: center center;
      height: 220px;
      padding: 20px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;

      h1 {
        margin: 0px 0 10px 0;
      }

      img {
        width: 150px;
      }
    }
  }
}
</style>
